export default __webpack_public_path__ + "static/media/updated-shot.8cabf1c6.jpg";